export const LANGUAGE_ENGLISH = 'en';
export const LANGUAGE_ESTONIAN = 'et';
export const LANGUAGE_LABELS = 'cimode';

export const SUPPORTED_LANGUAGES = [
  LANGUAGE_ESTONIAN,
  LANGUAGE_ENGLISH,
  LANGUAGE_LABELS,
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];
